import { useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

const AUTO_MS = 3000;
const TRANSITION_MS = 700;

export const Section7 = () => {
  const mobile = useResponsiveMobile(900);

  const cards = useMemo(
    () => [
      {
        title: mobile ? (
          <>
            가맹점 정산 지급 시간이 <br />월 40시간에서 2시간으로 <br /> 줄었습니다.
          </>
        ) : (
          <>
            가맹점 정산 지급 시간이 <br />월 40시간에서 2시간으로 줄었습니다.
          </>
        ),
        desc: mobile ? (
          <>
            수기로 했어야 했던 리포트 생성, <br /> 입금, 세금계산서, 미수금 관리까지
            <br />
            모두 자동으로 하니 한 사람만 있으면 <br /> 충분해요
          </>
        ) : (
          <>
            수기로 했어야 했던 리포트 생성, 입금, 세금계산서, 미수금 관리까지 <br />
            모두 자동으로 하니 한 사람만 있으면 충분해요
          </>
        ),
        who: "소상공 파트너 A사 대표",
        avatar: "/assets/images/icon/customer.png",
      },
      {
        title: mobile ? (
          <>
            품을 통해 자금 유동성 확보가 <br />
            쉬워져서 걱정 없이 영업에만 <br /> 집중할 수 있게 됐어요!
          </>
        ) : (
          <>
            품을 통해 자금 유동성 확보가 쉬워져서 <br />
            걱정 없이 영업에만 집중할 수 있게 됐어요!
          </>
        ),
        desc: mobile ? (
          <>
            덕분에 파트너 만족도도 올라가고, <br />
            우리 회사는 안정적인 부가수익을 얻어 <br /> 서로 만족하고 있습니다.
          </>
        ) : (
          <>
            덕분에 파트너 만족도도 올라가고, <br />
            우리 회사는 안정적인 부가수익을 얻어 서로 만족하고 있습니다.
          </>
        ),
        who: "B2B 플랫폼 B사 운영팀장",
        avatar: "/assets/images/icon/customer2.png",
      },
      {
        title: mobile ? (
          <>
            영업대행사와 가맹점을 <br /> 한 곳에서 관리할 수 있는
            <br />
            시스템이 정말 효율적이에요.
          </>
        ) : (
          <>
            영업대행사와 가맹점을 <br /> 한 곳에서 관리할 수 있는
            <br />
            시스템이 정말 효율적이에요.
          </>
        ),
        desc: mobile ? (
          <>
            파트너사에 데이터를 <br /> 투명하게 공유할 수 있어
            <br />
            신뢰가 쌓이고, 복잡했던 <br /> 정산까지 자동화되어
            <br />
            운영 부담이 크게 줄었습니다.
          </>
        ) : (
          <>
            파트너사에 데이터를 투명하게 공유할 수 있어
            <br />
            신뢰가 쌓이고, 복잡했던 정산까지 자동화되어
            <br />
            운영 부담이 크게 줄었습니다.
          </>
        ),
        who: "영업대행 C사 총괄 매니저",
        avatar: "/assets/images/icon/customer2.png",
      },
    ],
    [mobile],
  );

  const [activeRealIndex, setActiveRealIndex] = useState(0);

  const activeStyle: React.CSSProperties = {
    background:
      "linear-gradient(0deg, #FFFFFF, #FFFFFF) padding-box, " +
      "linear-gradient(90deg, #0079FF 0%, #00FF44 56.09%, #FFC400 100%) border-box",
    border: "3px solid transparent",
    borderRadius: "24px",
    boxSizing: "border-box",
  };

  const inactiveStyle: React.CSSProperties = {
    background: "#FFFFFF",
    border: "3px solid transparent",
    borderRadius: "24px",
    boxSizing: "border-box",
    boxShadow: "inset 0 0 0 1px #EEF0F4",
  };

  return (
    <section className="pl-[24px] md:px-[120px] md:pb-[160px] pb-[20px] flex justify-center">
      <div className="flex flex-col gap-[40px] md:gap-[100px] w-full max-w-[1440px]">
        {/* 상단 텍스트 동일 */}
        <div className="flex flex-col gap-[32px] md:gap-[50px]">
          <div className="flex flex-col gap-3">
            <span className="font-normal text-[#0079FF] md:text-xl md:text-start text-center">
              고객사례
            </span>
            <h1 className="font-bold text-center md:text-start text-[36px] md:text-display text-[#121319]">
              품과 함께한 고객사
            </h1>
          </div>
          <span className="font-normal text-[18px] md:text-heading1 text-center md:text-start text-[#4D4F58]">
            품을 도입한 이후, 운영이 단순해지고 {mobile ? <br /> : ""} 파트너 관계가 달라졌어요
          </span>
        </div>

        <div className="w-full overflow-hidden">
          <Swiper
            modules={[Autoplay]}
            loop
            speed={TRANSITION_MS}
            autoplay={
              mobile
                ? false
                : { delay: AUTO_MS, disableOnInteraction: false, pauseOnMouseEnter: true }
            }
            slidesPerView={mobile ? 1.3 : 2}
            spaceBetween={mobile ? 16 : 32}
            onSlideChange={(swiper) => setActiveRealIndex(swiper.realIndex)}
            className="!overflow-visible"
          >
            {cards.map((card, index) => {
              const isActive = index === activeRealIndex;

              return (
                <SwiperSlide key={card.who}>
                  <div
                    className="relative flex h-full min-h-[497px] md:min-h-[667px] flex-col p-[24px] md:p-[40px]"
                    style={isActive ? activeStyle : inactiveStyle}
                  >
                    <div className="flex flex-col gap-[24px] md:gap-[32px]">
                      <img
                        loading="lazy"
                        className="md:w-[56px] md:h-[48px] w-7 h-6"
                        src="/assets/images/icon/double_quotes.png"
                        alt=""
                      />
                      <div className="flex flex-col gap-4">
                        <p className="font-semibold text-[20px] md:text-display3 text-[#121319] leading-snug">
                          {card.title}
                        </p>
                        <p className="text-[16px] md:text-heading3 text-[#4D4F58] leading-relaxed">
                          {card.desc}
                        </p>
                      </div>
                      <img
                        loading="lazy"
                        className="md:w-[56px] md:h-[48px] w-7 h-6"
                        src="/assets/images/icon/double_quotes2.png"
                        alt=""
                      />
                    </div>

                    <div className="mt-auto flex flex-col gap-[16px] md:gap-[32px]">
                      <span className="text-[16px] md:text-heading1 text-[#4D4F58]">
                        {card.who}
                      </span>
                      <img
                        loading="lazy"
                        src={card.avatar}
                        alt={`${card.who} avatar`}
                        className="h-[60px] w-[60px] md:h-[60px] md:w-[60px] rounded-full"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
